import { useEffect, useState } from 'react'

import { Button } from 'components/ui/Button/Button'
import { IconButton } from 'components/ui/Button/IconButton/IconButton'
import { Input } from 'components/ui/Input/Input'
import { Slider } from 'components/ui/Slider/Slider'

export interface ContainerSealFilterProps {
  onSelect?: (value: number) => void
  values: number
}

export const ContainerSealFilter = ({ onSelect, values = 0 }: ContainerSealFilterProps) => {
  const [text, setText] = useState<string>('')
  const [isActive, setIsActive] = useState<boolean>(false)
  const [inputValue, setInputValue] = useState<string>('')

  useEffect(() => {
    if (values <= 0) {
      setText('Номер пломбы')
      return
    }

    setText(`Пломба №${values}`)
  }, [values])

  const handleOnSubmit = () => setIsActive(true)

  const handleFilterClose = () => {
    setIsActive(false)

    if (values <= 0) {
      setInputValue('')
      return
    }

    setInputValue(values.toString())
  }

  const handleFilterSubmit = () => {
    setIsActive(false)

    const value = Number(inputValue)

    if (Number.isNaN(value)) {
      onSelect?.(0)
      setInputValue('')

      return
    }

    onSelect?.(value)
  }

  return (
    <>
      <IconButton title={text} icon="arrow" outline round onSubmit={handleOnSubmit}></IconButton>
      <Slider isActive={isActive} onClose={handleFilterClose} height="200px">
        <div className="filter-wheel__slider">
          <h2>Фильтр по номеру пломбы</h2>
          <div className="filter-wheel__slider-items">
            <Input value={inputValue} onChange={setInputValue} />
          </div>
          <div className="filter-wheel__slider_controlls flex-center">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Применить" handleOnSubmit={handleFilterSubmit}></Button>
            </span>
            <Button title="Отменить" outline handleOnSubmit={handleFilterClose}></Button>
          </div>
        </div>
      </Slider>
    </>
  )
}
